// !(function () {
//     "use strict";
//     function t() {
//         return (document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth) < window.theme.sizes.small;
//     }
//     const e = "[data-image-id]",
//         s = "product-images",
//         i = "[data-section-type]",
//         o = "[data-thumb-item]",
//         r = "[data-thumb-link]",
//         n = "[data-thumbs-slider]",
//         a = "data-active-media",
//         c = "data-media-id",
//         d = "is-active";
//     class u extends HTMLElement {
//         constructor() {
//             super(),
//                 (this.container = this.closest(i)),
//                 (this.productImages = this.container.querySelectorAll(e)),
//                 (this.productImagesContainer = this.container.querySelector(s)),
//                 (this.productThumbs = this.container.querySelectorAll(o)),
//                 (this.thumbSlider = this.querySelector(n)),
//                 (this.thumbLinks = this.querySelectorAll(r));
//         }
//         connectedCallback() {
//             this.handleEvents(), this.preloadImagesOnHover(), this.activeMediaObserver();
//         }
//         disconnectedCallback() {
//             this.observer && this.observer.disconnect();
//         }
//         activeMediaObserver() {
//             (this.observer = new MutationObserver((t) => {
//                 for (const e of t) "attributes" === e.type && e.attributeName == a && this.setActiveThumb();
//             })),
//                 this.observer.observe(this.productImagesContainer, { attributes: !0, childList: !1, subtree: !1 });
//         }
//         handleEvents() {
//             this.thumbLinks.forEach((t) => {
//                 t.addEventListener("click", (e) => {
//                     e.preventDefault();
//                     const s = t.closest(o),
//                         i = t.getAttribute(c);
//                     s.classList.contains(d) || this.dispatchEvent(new CustomEvent("theme:media:select", { bubbles: !0, detail: { id: i } }));
//                 }),
//                     t.addEventListener("keyup", (e) => {
//                         if ("Enter" === e.code) {
//                             const e = t.getAttribute(c),
//                                 s = this.productImagesContainer.querySelector(`[${c}="${e}"]`)?.querySelectorAll('model-viewer, video, iframe, button, [href], input, [tabindex]:not([tabindex="-1"])')[0];
//                             s && (s.dispatchEvent(new Event("focus")), s.dispatchEvent(new Event("select")));
//                         }
//                     });
//             });
//         }
//         preloadImagesOnHover() {
//             this.thumbLinks.forEach((t) => {
//                 t.addEventListener("mouseover", () => {
//                     const e = t.getAttribute(c);
//                     this.productImagesContainer.querySelector(`[${c}="${e}"] img`)?.setAttribute("loading", "eager");
//                 });
//             });
//         }
//         setActiveThumb() {
//             const t = this.productImagesContainer.getAttribute(a),
//                 e = this.querySelector(`[${c}="${t}"]`);
//             this.querySelector(`${o}.${d}`)?.classList.remove(d),
//                 e?.parentNode.classList.add(d),
//                 requestAnimationFrame(() => {
//                     this.scrollToThumb();
//                 });
//         }
//         scrollToThumb() {
//             const e = this.thumbSlider;
//             if (e) {
//                 const s = e.querySelector(`.${d}`);
//                 if (!s) return;
//                 const i = e.scrollTop,
//                     o = e.scrollLeft,
//                     r = e.offsetWidth,
//                     n = e.offsetHeight,
//                     a = i + n,
//                     c = o + r,
//                     u = s.offsetTop,
//                     l = s.offsetLeft,
//                     h = s.offsetWidth,
//                     m = s.offsetHeight,
//                     b = i > u,
//                     v = o > l,
//                     f = l + h > c,
//                     p = u + m > a || b,
//                     g = f || v,
//                     E = t();
//                 if (p || g) {
//                     let t = u - n + m,
//                         s = l - r + h;
//                     b && (t = u), f && E && (s += parseInt(window.getComputedStyle(e).paddingRight)), v && ((s = l), E && (s -= parseInt(window.getComputedStyle(e).paddingLeft))), e.scrollTo({ top: t, left: s, behavior: "smooth" });
//                 }
//             }
//         }
//     }
//     customElements.get("product-thumbs") || customElements.define("product-thumbs", u);
// })();




const selectors = {
  productImage: '[data-image-id]',
  productImagesContainer: 'product-images',
  section: '[data-section-type]',
  thumbItem: '[data-thumb-item]',
  thumbLink: '[data-thumb-link]',
  thumbSlider: '[data-thumbs-slider]',
};

const attributes = {
  activeMedia: 'data-active-media',
  mediaId: 'data-media-id',
};

const classes = {
  active: 'is-active',
  focused: 'is-focused',
  mediaActive: 'media--active',
  mediaHidden: 'media--hidden',
  mediaHiding: 'media--hiding',
};
  function t() {
        return (document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth) < window.theme.sizes.small;
    }
class ProductThumbs extends HTMLElement {
  constructor() {
    super();

    window.thumb_events = this;
    this.container = this.closest(selectors.section);
    this.productImages = this.container.querySelectorAll(selectors.productImage);
    this.productImagesContainer = this.container.querySelector(selectors.productImagesContainer);
    this.productThumbs = this.container.querySelectorAll(selectors.thumbItem);
    this.thumbSlider = this.querySelector(selectors.thumbSlider);
    this.thumbLinks = this.querySelectorAll(selectors.thumbLink);
  }

  connectedCallback() {
    this.handleEvents();
    this.preloadImagesOnHover();
    this.activeMediaObserver();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  activeMediaObserver() {
    const config = {attributes: true, childList: false, subtree: false};

    // Callback function to execute when mutations are observed
    const callback = (mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'attributes' && mutation.attributeName == attributes.activeMedia) {
          this.setActiveThumb();
        }
      }
    };

    this.observer = new MutationObserver(callback);
    this.observer.observe(this.productImagesContainer, config);
  }

  handleEvents() {
     document.querySelectorAll('product-images product-thumbs .product__thumb .product__thumb__link').forEach((thumb) => {
      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        const thumbItem = thumb.closest(selectors.thumbItem);
        const id = thumb.getAttribute(attributes.mediaId);

        // Do nothing if clicked on the active thumbnail
        if (thumbItem.classList.contains(classes.active)) return;

        // Dispatch media select event to show the related product image
        this.dispatchEvent(
          new CustomEvent('theme:media:select', {
            bubbles: true,
            detail: {
              id: id,
            },
          })
        );
      });

      thumb.addEventListener('keyup', (e) => {
        // On keypress Enter move the focus to the first focusable element in the related slide
        if (e.code === 'Enter') {
          const mediaId = thumb.getAttribute(attributes.mediaId);
          const mediaElem = this.productImagesContainer
            .querySelector(`[${attributes.mediaId}="${mediaId}"]`)
            ?.querySelectorAll('model-viewer, video, iframe, button, [href], input, [tabindex]:not([tabindex="-1"])')[0];
          if (mediaElem) {
            mediaElem.dispatchEvent(new Event('focus'));
            mediaElem.dispatchEvent(new Event('select'));
          }
        }
      });
    });
  }

  // Preload product images when hover on a related thumbnail
  preloadImagesOnHover() {
    document.querySelectorAll('product-images product-thumbs .product__thumb .product__thumb__link').forEach((thumb) => {
      thumb.addEventListener('mouseover', () => {
        const id = thumb.getAttribute(attributes.mediaId);
        const productImage = this.productImagesContainer.querySelector(`[${attributes.mediaId}="${id}"] img`);
        productImage?.setAttribute('loading', 'eager');
      });
    });
  }

  setActiveThumb() {
    const id = this.productImagesContainer.getAttribute(attributes.activeMedia);
    const selectedThumb = this.querySelector(`[${attributes.mediaId}="${id}"]`);

    // Remove class active from the previously selected thumbnail
    this.querySelector(`${selectors.thumbItem}.${classes.active}`)?.classList.remove(classes.active);

    // Add class active to the selected thumbnail
    selectedThumb?.parentNode.classList.add(classes.active);

    requestAnimationFrame(() => {
      this.scrollToThumb();
    });
  }
  

  scrollToThumb() {
    const thumbs = document.querySelector('product-images product-thumbs .product__thumbs__holder');

    if (thumbs) {
      const thumb = thumbs.querySelector(`.${classes.active}`);
      if (!thumb) return;
      const thumbsScrollTop = thumbs.scrollTop;
      const thumbsScrollLeft = thumbs.scrollLeft;
      const thumbsWidth = thumbs.offsetWidth;
      const thumbsHeight = thumbs.offsetHeight;
      const thumbsPositionBottom = thumbsScrollTop + thumbsHeight;
      const thumbsPositionRight = thumbsScrollLeft + thumbsWidth;
      const thumbPosTop = thumb.offsetTop;
      const thumbPosLeft = thumb.offsetLeft;
      const thumbWidth = thumb.offsetWidth;
      const thumbHeight = thumb.offsetHeight;
      const thumbRightPos = thumbPosLeft + thumbWidth;
      const thumbBottomPos = thumbPosTop + thumbHeight;
      const topCheck = thumbsScrollTop > thumbPosTop;
      const bottomCheck = thumbBottomPos > thumbsPositionBottom;
      const leftCheck = thumbsScrollLeft > thumbPosLeft;
      const rightCheck = thumbRightPos > thumbsPositionRight;
      const verticalCheck = bottomCheck || topCheck;
      const horizontalCheck = rightCheck || leftCheck;
      const isMobileView = t();

      if (verticalCheck || horizontalCheck) {
        let scrollTopPosition = thumbPosTop - thumbsHeight + thumbHeight;
        let scrollLeftPosition = thumbPosLeft - thumbsWidth + thumbWidth;

        if (topCheck) {
          scrollTopPosition = thumbPosTop;
        }

        if (rightCheck && isMobileView) {
          scrollLeftPosition += parseInt(window.getComputedStyle(thumbs).paddingRight);
        }

        if (leftCheck) {
          scrollLeftPosition = thumbPosLeft;

          if (isMobileView) {
            scrollLeftPosition -= parseInt(window.getComputedStyle(thumbs).paddingLeft);
          }
        }

        thumbs.scrollTo({
          top: scrollTopPosition,
          left: scrollLeftPosition,
          behavior: 'smooth',
        });
      }
    }
  }
}

if (!customElements.get('product-thumbs')) {
  customElements.define('product-thumbs', ProductThumbs);
}
